import React, { useState } from "react";

const Test = () => {
  const [product, setProduct] = useState("");
  const [prodCode, setProdCode] = useState("");
  const [prodSubCode, setProdSubCode] = useState("");
  const [amount, setAmount] = useState("");
  const [beneAcctNo, setBeneAcctNo] = useState("");

  const handleProductChange = (event) => {
    const selectedProduct = event.target.value;
    setProduct(selectedProduct);

    let newProdCode, newProdSubCode, newAmount, newBeneAcctNo;
    const precision = 100; // 2 decimals
    const randomnum =
      Math.floor(
        Math.random() * (500 * precision - 1 * precision) + 1 * precision
      ) /
      (1 * precision);

    switch (selectedProduct) {
      case "AIS":
        newProdCode = "517";
        newProdSubCode = "777701023";
        newAmount = randomnum;
        newBeneAcctNo = "3247821000";
        break;
      case "AST":
        newProdCode = "517";
        newProdSubCode = "777701032";
        newAmount = randomnum;
        newBeneAcctNo = "0812345678";
        break;
      case "MIPAY":
        newProdCode = "517";
        newProdSubCode = "7777013219";
        newAmount = randomnum;
        newBeneAcctNo = "70000001778";
        break;
      case "OTR":
        newProdCode = "517";
        newProdSubCode = "7777013208";
        newAmount = randomnum;
        newBeneAcctNo = "17224886903365805374";
        break;
      case "014":
        newProdCode = "014";
        newProdSubCode = "00000500";
        newAmount = 5;
        newBeneAcctNo = "0141234567";
        break;
      case "016":
        newProdCode = "016";
        newProdSubCode = "00001000";
        newAmount = 10;
        newBeneAcctNo = "0161234567";
        break;
      case "017":
        newProdCode = "017";
        newProdSubCode = "00003000";
        newAmount = 30;
        newBeneAcctNo = "0121234567";
        break;
      case "019":
        newProdCode = "019";
        newProdSubCode = "00005000";
        newAmount = 50;
        newBeneAcctNo = "0191234567";
        break;
      case "066":
        newProdCode = "066";
        newProdSubCode = "00001000";
        newAmount = 10;
        newBeneAcctNo = "0101234567";
        break;
      case "098":
        newProdCode = "098";
        newProdSubCode = "00000500";
        newAmount = 5;
        newBeneAcctNo = "0131234567";
        break;
      case "099":
        newProdCode = "099";
        newProdSubCode = "00000500";
        newAmount = 5;
        newBeneAcctNo = "0141234567";
        break;
      default:
        newProdCode = "";
        newProdSubCode = "";
        newAmount = "";
        newBeneAcctNo = "";
    }

    setProdCode(newProdCode);
    setProdSubCode(newProdSubCode);
    setAmount(newAmount);
    setBeneAcctNo(newBeneAcctNo);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const sProdCode = prodCode;
    const sProdSubCode = prodSubCode;
    const sAmt = amount * 100;
    const sBeneAcctNo = beneAcctNo;
    const sNewURL = `app://mobilityone.mipay.vas/?ProdCode=${sProdCode}&ProdSubCode=${sProdSubCode}&Amt=${sAmt}&BeneAcctNo=${sBeneAcctNo}`;
    window.location.href = sNewURL; 
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">M1 Demo MiniApp</h1>
      <div className="mb-4">
        <h2 className="text-xl font-semibold">
          Test SuperApp Top Up (AIS Air Selangor)
        </h2>
        <a
          href="app://mobilityone.mipay.vas/?ProdCode=517&ProdSubCode=777701023&Amt=1234&BeneAcctNo=3247821000"
          className="text-blue-500 hover:underline"
        >
          Test AIS
        </a>
      </div>

      <div className="mb-4">
        <h2 className="text-xl font-semibold">Test S4S prepaid Top Up</h2>
        <a
          href="app://mobilityone.mipay.vas/?ProdCode=098&ProdSubCode=00000500&Amt=500&BeneAcctNo=0131234567"
          className="text-blue-500 hover:underline"
        >
          Test S4S Prepaid
        </a>
      </div>

      <div className="mb-4">
        <h2 className="text-xl font-semibold">Test du'a call prepaid Top Up</h2>
        <a
          href="app://mobilityone.mipay.vas/?ProdCode=099&ProdSubCode=00000500&Amt=500&BeneAcctNo=0141234567"
          className="text-blue-500 hover:underline"
        >
          Test du'a call Prepaid
        </a>
      </div>

      <h2 className="text-xl font-semibold mb-4">Test VAS</h2>
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-md"
      >
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="product"
              className="block text-sm font-medium text-gray-700"
            >
              Product
            </label>
            <select
              id="product"
              name="product"
              value={product}
              onChange={handleProductChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            >
              <option value="">(please select)</option>
              <option value="AIS">AIS-Air Selangor</option>
              <option value="AST">ASTRO</option>
              <option value="MIPAY">MiPAY TopUp</option>
              <option value="OTR">OTR-OTR PayLater</option>
              <option value="014">U Mobile Prepaid</option>
              <option value="016">DiGi Prepaid</option>
              <option value="017">Maxis Hotlink</option>
              <option value="019">Celcom XPax</option>
              <option value="066">Touch 'n Go</option>
              <option value="098">S4S Prepaid</option>
              <option value="099">du'a call Prepaid</option>
            </select>
          </div>

          <div>
            <label
              htmlFor="prodCode"
              className="block text-sm font-medium text-gray-700"
            >
              ProdCode
            </label>
            <input
              type="text"
              name="txtProdCode"
              id="txtProdCode"
              value={prodCode}
              readOnly
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label
              htmlFor="prodSubCode"
              className="block text-sm font-medium text-gray-700"
            >
              ProdSubCode
            </label>
            <input
              type="text"
              name="txtProdSubCode"
              id="txtProdSubCode"
              value={prodSubCode}
              readOnly
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700"
            >
              Amount
            </label>
            <input
              type="text"
              name="txtAmt"
              id="txtAmt"
              value={amount}
              readOnly
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label
              htmlFor="beneAcctNo"
              className="block text-sm font-medium text-gray-700"
            >
              BeneAcctNo
            </label>
            <input
              type="text"
              name="txtBeneAcctNo"
              id="txtBeneAcctNo"
              value={beneAcctNo}
              readOnly
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>

        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Send
          </button>
          <button
            type="reset"
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded ml-4"
          >
            Reset
          </button>
        </div>
      </form>
    </div>
  );
};

export default Test;
